const projects = {
  title: 'Workspaces',
  remove_project: 'Remove workspace',
  particular_project_users: '{{project}} Users',
  project_users: 'Project Users',
  create_new: 'Create a new workspace',
  create_first: 'Create first workspace',
  remove: 'Remove workspace',
  edit_name: 'Edit name',
  select_or_create_any: 'Select of create any workspace',
  loading: 'Loading workspaces...',
  name: 'Name',
  name_placeholder: 'Workspace title',
  remove_text_1: 'This will remove workspace {{name}}',
  remove_text_2:
    ' Do not worry, it still will be available in the “Deleted workspaces" section. You will be able to either restore it or delete completely.',
  created_at: 'Created at {{createdAt}}',
  search_files: 'Search files',
  document: {
    loading_current: 'Loading current document...',
  },
  file_key: 'File key',
  file_key_placeholder: 'Please input the file key',
  input_file_key: 'Input file key of your document',
  input_file_key_description:
    'Please input the file key of the figma document you are using - you will find it in URL address of your Figma file.',
  documents: {
    loading: 'Loading documents...',
  },
  invite_user: {
    email: 'Email',
    email_placeholder: 'Email of the user',
    role: 'Role',
    role_placeholder: 'Role of the invited user',
  },
  user: {
    invite: 'Invite user',
    remove: 'Remove user',
    name_and_email: 'Name & Email',
    team_role: 'Team role',
    last_active: 'Last active',
    added: 'Added',
    remove_from_project_text_1:
      'Do you want to remove user from the workspace?',
    remove_from_project_text_2:
      '{{ user }} will no longer be able to access {{ project }} workspace and any resources within it.',
    not_activated: 'Not activated',
  },
  sort: {
    by: 'Sort by',
    user_name_asc: 'Name (A-Z)',
    user_name_desc: 'Name (Z-A)',
    name_asc: 'Name (A-Z)',
    name_desc: 'Name (Z-A)',
    date_created_asc: 'Date created (New-Old)',
    date_created_desc: 'Date created (Old-New)',
  },
  sync: {
    title: 'Sync',
    cancel: 'Cancel',
    modal_header: 'Sync a workspace',
    done: 'Synced',
    error: 'Sync error',
    in_progress: 'Syncing',
    was_finished: 'Sync was finished, ',
    click_to_update_page: 'click to update the page',
    click_to_try_again: 'click to try again',
    sync_project_failed: 'Sync failed. See the logs below',
    sync_project_success: 'Workspace synced successfully',
    sync_project_in_progress: 'Sync in progress',
    sync_error: 'Sync failed. Click to open logs',
    synced: 'Synced successfully. Click to open logs',
    syncing_in_progress: 'Sync in progress. Click to open logs',
    never_synced: 'Never synced',
    not_allowed_missing_access:
      'You are not allowed to sync - you need access to all linked Figma files.',
    need_to_sync: 'You need to sync your workspace first.',
  },
  publication: {
    how_to_use: {
      title: 'How to use published package',
      description:
        'Depending on the package manager you use, paste one of the following commands in CLI using your Velocity <tag>account username ({{username}})</tag> and password to authenticate.',
    },
  },
  version: {
    label: 'Package version',
    placeholder: 'Enter package version (semver)',
    current_version: 'Current version: {{currentVersion}}',
  },
  validation: {
    email_cannot_be_empty: "Email can't be empty",
    email_is_not_valid: 'Email is not valid',
    role_cannot_be_empty: "Role can't be empty",
    role_is_not_valid: 'Role is not valid',
    version_cannot_be_empty: "Version can't be empty",
    version_is_not_valid:
      'Version is not valid - required x.y.z format with only numbers acceptable',
  },
  errors: {
    cannot_create:
      'Error while creating workspace. Try again by clicking on the button below',
    cannot_remove:
      'Error while removing workspace. Try again by clicking on the button below',
    no_styles: 'This workspace has no styles',
    some_files_never_synced:
      'Some files from this workspace was never synced, please run Sync',
    no_styles_for_query: 'No styles found for your request',
    no_frames:
      'This workspace has no frames. Please tag some frames using Figma Plugin',
    no_frames_for_query: 'No frames found for your request',
    cannot_load: 'Error while loading workspaces',
    cannot_load_users: 'Error while loading workspace users',
    cannot_load_styles: 'Error while loading workspace styles',
    error_while_running_queue: 'Error while running a sync queue',
    some_files_not_synced: 'Some files were not synced, ',
    error_during_sync: 'Error occurred during sync',
    cannot_save_document: 'Error with saving document. ',
    cannot_load_document: 'Error while loading document',
    documents_not_found: 'No documents found',
    cannot_load_frames: 'Error while loading workspace frames',
    cannot_invite_user_to_project:
      'Error while inviting the user to the workspace. Try again by clicking on the button below',
    cannot_remove_user_from_project:
      'Error while removing user from workspace. Try again by clicking on the button below',
    identifier_already_taken: 'This identifier is already taken.',
    incorrect_version:
      'Can not use this version, new version must be greater than the last one',
    file_key_cannot_be_empty: 'File key can not be empty',
    incorrect_file_key:
      'Provided file key is incorrect or other error happened',
  },
} as const;

export default projects;
